import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "@tanstack/react-router";

import { getDeal, type Deal } from "@/api/client";
import { useCurrentUser } from "@/auth/useCurrentUser";
import { DealConfirmation } from "@/components/deals/DealConfirmation";

export function PartnerDealConfirmationRoute() {
  const { accessToken } = useCurrentUser();
  const { dealId } = useParams({ from: "/dashboard/partner/deals/$dealId/confirmation" });

  const deal = useQuery<Deal>({
    queryKey: ["deals", "detail", dealId, accessToken],
    queryFn: () => getDeal(accessToken!, dealId),
    enabled: !!accessToken && !!dealId,
  });

  if (deal.isLoading)
    return (
      <p role="status" className="container py-6">
        Loading...
      </p>
    );
  if (deal.error)
    return (
      <div className="container py-6">
        <p role="alert">Couldn't load this deal.</p>
        <p className="mt-2 text-sm">
          <Link to="/dashboard/partner/deals">Back to my deals</Link>
        </p>
      </div>
    );
  if (!deal.data) return null;

  return <DealConfirmation deal={deal.data} />;
}
